<template>
    <div class="task-cate">
        <div class="cate-container">
            <el-select v-model="task_cate.first_level" placeholder="一级分类" style="width: 100%" clearable filterable
                size="medium" @click.native="loadLevel(0)" :loading="isLoading" @change="loadLevel">
                <el-option v-for="item in options_first_level" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <span style="margin-top: 0.15rem;margin-right: 0.1rem;">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-select v-model="task_cate.second_level" placeholder="二级分类" style="width: 100%" clearable filterable
                size="medium" :loading="isLoading" @change="handleSelected">
                <el-option v-for="item in options_second_level" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TaskCate',
    data() {
        return {
            task_cate: {
                first_level: '',
                second_level: '',
            },
            isLoading: false,
            options_first_level: [],
            options_second_level: []
        }
    },
    methods: {
        loadLevel(id) {
            // console.log(id, 'id')
            this.isLoading = true
            this.$axios
                .get("/api/api3_call_task_load_task_first_level", {
                    params: {
                        id
                    },
                    loadingClose: true,
                })
                .then(({ data }) => {
                    if (data.code === 0) {
                        this.isLoading = false
                        if (id === 0) {
                            this.options_first_level = data.data;
                        } else {
                            this.options_second_level = data.data;
                        }
                    }
                })
                .catch();
        },
        handleSelected(id) {
            this.$emit('handleSelected',id)
        }
    }
}
</script>

<style scoped>
.task-cate .cate-container {
    display: flex;
    margin-bottom: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/CallTaskResource/components/TaskCate.vue